import { FogExp2 } from '../../thirdparty/three/imports';
import { FogBase3D } from './FogBase3D';

export interface FogExp23D
{
    get _fog(): FogExp2;
    set _fog(v);
}

export class FogExp23D extends FogBase3D
{
    constructor(color: number | string, density = 0.00025)
    {
        super();
        this._fog = new FogExp2(color, density);
    }
}
